<template>
    <v-layout row>
        <v-flex
                xs12
                sm6
                offset-sm3
        >
            <v-card v-if="consents && consents.length > 0">
                <v-list
                        two-line
                >
                    <v-tabs
                            fixed
                            centered
                            v-model="filter"
                    >
                        <v-tabs-bar class="grey lighten-5">
                            <v-tabs-slider class="accent"></v-tabs-slider>
                            <v-tabs-item
                                    ripple
                                    v-for="tab in tabs"
                                    :key="tab"
                                    :href="'#' + tab"
                            >
                                {{ tab }}
                            </v-tabs-item>
                        </v-tabs-bar>
                    </v-tabs>

                    <v-list-tile
                            avatar
                            ripple
                            v-for="(item, index) in consents"
                            :key="key(item)"
                            @click="details(item, index)"
                    >
                        <v-list-tile-avatar>
                            <v-icon :class="item.Status">fa-code-fork</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title class="bold">{{ item.Intent.ShortDescription }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ format(item.Expiration) }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-icon class="visible-hover">mode_edit</v-icon>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapState } from 'vuex';
    import userReadable from '../utils/time';

    export default {
        name: 'Consents',
        data() {
            return {
                tabs: ['all', 'granted', 'revoked'],
                active_tab: 'all',
            };
        },
        computed: {
            ...mapState('consents', {
                consents: state => state.consents,
            }),
            filter: {
                get() {
                    return this.$store.state.consents.filter;
                },
                set(filter) {
                    this.$store.dispatch('consents/LOAD_MY_CONSENTS_FILTER', filter);
                },
            },
        },
        methods: {
            key(consent) {
                return `${consent.IntentIssuerCode}_${consent.IntentCode}_${consent.DataOwnerCode}`;
            },
            details(item) {
                this.$router.push({ path: `/consents/${item.IntentIssuerCode}/${item.IntentCode}` });
            },
            format(time) {
                return userReadable(time);
            },
        },
        created() {
            this.$store.dispatch('consents/LOAD_MY_CONSENTS');
        },
    };
</script>

<style lang="stylus" scoped>
    @import '../../node_modules/vuetify/src/stylus/theme'

    .list
        &__tile
            .visible-hover
                visibility hidden

        :hover
            .visible-hover
                visibility visible

    .granted
        color: $theme.success

    .expired
        color: $theme.warning

    .revoked
        color: $theme.error
</style>



// WEBPACK FOOTER //
// Consents.vue?0b9311b6